export const DistributionEndPoints = {
  getReportsEmailSettings: {
    url: (company, project) =>
      `/rest/v1/getReportsEmailSettings/${company}/${project}`,
    method: `POST`,
  },

  updateReportsEmailSettings: {
    url: (company, project) =>
      `/rest/v1/updateReportsEmailSettings/${company}/${project}`,
    method: `PUT`,
  },

  createReportsEmailSettings: {
    url: (company, project) =>
      `/rest/v1/createReportsEmailSettings/${company}/${project}`,
    method: `POST`,
  },

  sendOutReportsEmails: {
    url: (company, project) =>
      `/rest/v1/sendOutReportsEmails/${company}/${project}`,
    method: `POST`,
  },

  deleteReportsEmailSettings: {
    url: (company, project) =>
      `/rest/v1/deleteReportsEmailSettings/${company}/${project}`,
    method: `DELETE`,
  },

  getWarehouseReportsEmailSettings: {
    url: (company) => `/rest/v1/getWarehouseReportsEmailSettings/${company}`,
    method: `POST`,
  },

  createWarehouseReportsEmailSettings: {
    url: (company) => `/rest/v1/createWarehouseReportsEmailSettings/${company}`,
    method: `POST`,
  },

  updateWarehouseReportsEmailSettings: {
    url: (company) => `/rest/v1/updateWarehouseReportsEmailSettings/${company}`,
    method: `PUT`,
  },

  deleteWarehouseReportsEmailSettings: {
    url: (company) => `/rest/v1/deleteWarehouseReportsEmailSettings/${company}`,
    method: `DELETE`,
  },

  sendOutWarehouseReportsEmails: {
    url: (company) => `/rest/v1/sendOutWarehouseReportsEmails/${company}`,
    method: `POST`,
  },

  // readAllCustomReportsInfo: {
  //   url: (company, project) =>
  //     `/rest/v1/readAllCustomReportsInfo/${company}/${project}`,
  //   method: `GET`,
  // },
};
